import React from "react";
import CustomApprovalModal from "@/shared/components/custom-modal";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import { Text } from "@chakra-ui/react";
import useWithdrawClaimDetail from "@/features/my-order/features/order-history/features/claim/hooks/useWithdrawClaimDetail";
import { useRecoilValue } from "recoil";
import claimDetailIdStore from "@/features/my-order/features/order-history/stores/useClaimDetailIdStore";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

function OrderHistoryClaimDetailWithdrawModal({ isOpen, onClose }: Props) {
  const { tTitle, tSentence } = useI18nHelper();
  const detailId = useRecoilValue(claimDetailIdStore);
  const { withdrawClaimDetail, isPending } = useWithdrawClaimDetail(detailId);

  return (
    <CustomApprovalModal isOpen={isOpen} onClose={onClose} isCentered={true}>
      <CustomApprovalModal.Header
        title={tSentence("order_history:claim.withdraw_modal_title")}
      />
      <CustomApprovalModal.Body>
        <Text textStyle={"body-md-regular"} color={"#6F6F6C"}>
          {tSentence("order_history:claim.withdraw_modal_description")}
        </Text>
      </CustomApprovalModal.Body>
      <CustomApprovalModal.Footer
        confirmName={tTitle("withdraw")}
        confirmBtnBgColor={"#CC1D1D"}
        onConfirm={() => {
          withdrawClaimDetail();
          onClose();
        }}
        onCancel={() => onClose()}
        isLoading={isPending}
      />
    </CustomApprovalModal>
  );
}

export default OrderHistoryClaimDetailWithdrawModal;
